<template>
  <v-container fluid>
    <VueOnGeoImageList :color="color"
                       title="Grupa kapitałowa:"
                       :subheaderFontSize="subheaderFontSize"
                       :headerFontSize="headerFontSize"
                       :isWebView="isWebView"
                       :items="groupItems"></VueOnGeoImageList>
    <VueOnGeoImageList :color="color"
                       :subheaderFontSize="subheaderFontSize"
                       :headerFontSize="headerFontSize"
                       :isWebView="isWebView"
                       title="W ramach grupy kapitałowej współpracujemy z:"
                       :items="cooperationItems"></VueOnGeoImageList>
  </v-container>
</template>

<script>
import VueOnGeoImageList from "./vue-ongeo-image-list.vue";
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";

export default {
  name: "vue-ongeo-partnership",
  mixins: [VueOnGeoGlobalMixin],
  props: {
    color: { type: String, default: "background" }
  },
  components: { VueOnGeoImageList },
  data: () => {
    return {
      groupItems: [
        {
          src: require("../assets/partnerzy-07_ongeo_services.svg"),
          href: "https://sklep.navigate.pl/"
        },
        {
          src: require("../assets/partnerzy-08_ongeo_services.svg"),
          href: "http://teledetekcja.smallgis.pl/"
        },
        {
          src: require("../assets/partnerzy-09_ongeo_services.svg"),
          href: "http://www.smallgis.pl/index.php/szkolenia/"
        }
      ],
      cooperationItems: [
        {
          src: require("../assets/partnerzy-01_ongeo_services.svg"),
          href: "https://baza.paih.gov.pl/"
        },
        {
          src: require("../assets/partnerzy-02_ongeo_services.svg"),
          href: "https://esip.bazaazbestowa.gov.pl/"
        },
        {
          src: require("../assets/partnerzy-03_ongeo_services.svg"),
          href: "https://emuia.gugik.gov.pl/"
        },
        {
          src: require("../assets/partnerzy-04_ongeo_services.svg"),
          href: "http://npkonsultacje.pl/"
        },
        {
          src: require("../assets/partnerzy-05_ongeo_services.svg"),
          href: "http://mpzp.gis-net.pl/gm/kaliska/"
        },
        {
          src: require("../assets/partnerzy-06_ongeo_services.svg"),
          href: "https://www.zitkof.kielce.eu/"
        }
      ]
    };
  }
};
</script>
